import { Component } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { MdIconRegistry } from '@angular/material';
import { AuthenticationService } from './shared/services/authentication.service';
import { Router } from '@angular/router';
import { environment } from 'environments/environment';

@Component({
  selector: 'qs-app',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {

  public _prod = environment.production;

  constructor(public _authService: AuthenticationService,
    private router: Router) {
  }

  logout() {
    this._authService.logout();
    this.router.navigate(['/login']);
  }
}



// WEBPACK FOOTER //
// C:/Users/orion/Projects/simplicityEngine/valmust/valmustfe/src/app/app.component.ts